import MapMarker from './components/mapmarker'

$(document).ready(function () {
  if($('.interactivemap').length > 0) {
    new MapMarker('#lesterresdenatae')
  }
});